import React, { memo } from "react";
import { Modal } from "antd";

import styles from "./styles.module.scss";
import PrivacyPolicy from "./PrivacyAndPolicy";

interface IPrivacyPolicyModal {
	visible: boolean;
	handleShowModal: any;
}

const PrivacyPolicyModal: React.FunctionComponent<
	IPrivacyPolicyModal
> = ({ visible, handleShowModal }) => {
	return (
		<Modal
			className={styles.modalContainer}
			visible={visible}
			onCancel={handleShowModal}
			cancelText={"Close"}
		>
			<PrivacyPolicy />
		</Modal>
	);
};

export default memo(PrivacyPolicyModal);
